import {
  selectCurrentCELs,
  selectFirstLoanRate,
  selectFirstLoanDate,
  selectFirstLoanAmount,
  selectFirstLoanTermYears
} from '../../../store/selectors/home/loans'
import moment from 'moment'
import sumBy from 'lodash/sumBy'
import { useIntl, defineMessages } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Text } from '@homebotapp/hb-react-component-catalog'
import { Format } from '../..'
import { openLoans } from '../../../actions/homeowner'
import { formatCurrency } from '../../../helpers/formatters'

export const MSG = defineMessages({
  intro: {
    id: 'Homeowner.yourLoans.intro',
    defaultMessage: '* Based on your'
  },
  introLong: {
    id: 'Homeowner.yourLoans.longIntro',
    defaultMessage: 'These calculations are all based on your'
  },
  single: {
    id: 'Homeowner.yourLoans.singleLoanDescription',
    defaultMessage: '{loanTerm} year loan at {loanRate} for {loanAmount} from {loanDate}. {reminder}'
  },
  multi: {
    id: 'Homeowner.yourLoans.multiLoanDescription',
    defaultMessage: '{numLoans} loans for {totalAmount}.'
  },
  btn: {
    id: 'Homeowner.yourLoans.updateLoansButton',
    defaultMessage: 'Update these loan numbers'
  },
  arm: {
    id: 'Homeowner.yourLoans.arm',
    defaultMessage:
      "(Remember: Your adjustable rate mortgage, or ARM, has a variable rate after the fixed rate period ends. ARM documents often show your loan's 30-year term to show what monthly payments might look like over the full term. Ask your lender for more information about your ARM!)"
  }
})

export interface YourLoanSentenceProps {
  long: boolean
}

export const YourLoanSentence = ({ long = false }) => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const loans = useSelector(selectCurrentCELs)
  const rate = useSelector(selectFirstLoanRate)
  const date = useSelector(selectFirstLoanDate)
  const amt = useSelector(selectFirstLoanAmount)
  const term = useSelector(selectFirstLoanTermYears)

  if (!loans?.length) return null

  return (
    <>
      {intl.formatMessage(long ? MSG.introLong : MSG.intro)}{' '}
      {loans.length === 1
        ? intl.formatMessage(MSG.single, {
            loanTerm: term,
            loanRate: (
              <Text as='span' size='xs' color='success'>
                <Format.Rate value={rate} />
              </Text>
            ),
            loanAmount: (
              <Text as='span' size='xs' color='success'>
                <Format.Currency value={Math.round(amt)} />
              </Text>
            ),
            loanDate: moment(date).format('MMMM YYYY'),
            reminder: loans[0].adjustable && (
              <Text size='2xs' color='warning' fontStyle='italic'>
                {intl.formatMessage(MSG.arm)}
              </Text>
            )
          })
        : intl.formatMessage(MSG.multi, {
            numLoans: loans.length,
            totalAmount: formatCurrency(sumBy(loans, 'amount'))
          })}{' '}
      <Button size='xs' colorScheme='primary' variant='ghost' onClick={() => dispatch(openLoans())}>
        {intl.formatMessage(MSG.btn)}
      </Button>
    </>
  )
}
